import styled from 'styled-components';

export default styled.div`
	--generic: var(--green-400);
	--internal: var(--teal-600);
	--external: var(--maroon-600);

	--person-avatar-size: var(--px-40);
	--person-avatar-border-radius: 50%;
	--person-avatar-bg: var(--generic);
	--person-avatar-co: var(--neutrals-00white);

	--person-initials-text-color: var(--person-avatar-co);
	--person-initials-background-color: var(--person-avatar-bg);

	&.sm {
		--person-avatar-size: var(--px-30);
	}
	&.md {
		--person-avatar-size: var(--px-40);
	}
	&.xl {
		--person-avatar-size: var(--px-120);
	}

	&.internal {
		--person-avatar-bg: var(--internal);
		.type {
			color: var(--internal);
		}
	}
	&.external {
		--person-avatar-bg: var(--external);
		.type {
			color: var(--external);
		}
	}

	display: flex;
	gap: var(--spacing-medium);
	align-items: center;
	justify-content: center;
	min-width: 0;
	flex: 1;

	aside {
		display: flex;
		flex-direction: column;
		min-width: 0;
		flex: 1;
		& > div {
			display: flex;
			min-width: 0;
			gap: var(--spacing-x-small);
		}
	}
`;
